<template>
  <div v-resize="updatePosPicker">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="tf-icone-toolbar-chat"
          :flat="!picker"
          icon
          color="primary"
          @click="showPicker"
        >
          <v-icon>sentiment_satisfied_alt</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Ajouter une emoticone')}}</span>
    </v-tooltip>

    <v-menu
      v-model="picker"
      lazy
      :close-on-content-click="false"
      transition="scale-transition"
      origin="bottom right"
      :max-width="width"
      :min-width="width"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <Picker
        native
        :perLine="8"
        :color="$vuetify.theme.secondary"
        :sheetSize="16"
        :emojiSize="20"
        :showSearch="true"
        :showPreview="false"
        :showSkinTones="false"
        :showCategories="true"
        @select="emoji => addEmoji(emoji)"
        :i18n="i18nPicker"
      ></Picker>
    </v-menu>
  </div>
</template>

<script>
// import { VTextarea } from 'vuetify/lib'
import { mapState } from 'vuex'
import { Picker } from 'emoji-mart-vue'
export default {
  // extends: VTextarea,
  name: 'wz-emoji-picker',

  components: {
    Picker
  },

  data () {
    return {
      picker: false,
      i18nPicker: {
        search: this.$t('search'),
        notfound: this.$t('emojiNotFound'),
        categories: {
          search: this.$t('emojiSearch'),
          recent: this.$t('emojiRecent'),
          people: this.$t('emojiPeople'),
          nature: this.$t('emojiNature'),
          foods: this.$t('emojiFoods'),
          activity: this.$t('emojiActivity'),
          places: this.$t('emojiPlaces'),
          objects: this.$t('emojiObjects'),
          symbols: this.$t('emojiSymbols'),
          flags: this.$t('emojiFlags'),
          custom: this.$tc('custom', 1, { count: '' })
        }
      },
      x: 0,
      y: 0,
      width: 265,
      height: 420,
      basicEmojis: [
        '+1',
        'grinning',
        'heart_eyes',
        'kissing_heart',
        'laughing',
        'stuck_out_tongue_winking_eye'
      ]
    }
  },

  props: {
    value: {
      required: false
    },
    // loading: {
    //   type: Boolean,
    //   required: true
    // },
    emoji: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['status', 'isConnected']),
    placeholder () {
      return this.status === 'offline' || !this.isConnected
        ? this.$t('currentlyOffline')
        : this.$t('typeYourMessage')
    }
  },

  methods: {
    updatePosPicker () {
      if (!this.$el) {
        return
      }
      let rect = this.$el.getBoundingClientRect()
      this.x = rect.left - this.width
      this.y = rect.top - this.height
    },
    showPicker () {
      this.picker = false
      this.updatePosPicker()
      this.$nextTick(() => {
        this.picker = true
      })
    },
    addEmoji (emoji) {
      this.$emit('addEmoji', emoji.native)
    }
  },

  watch: {
  }
}
</script>

<style>
.emoji-mart {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzEmojiPicker.vue